import type { ReactNode } from 'react';

import { buildComponent } from '../../utils/BuildComponent';
import { mapEntry } from '../../utils/map-entries';
import type { CompositionItem } from './config';
import { transforms } from './transforms';

export function resolveLegacyEntry(
    entry: Parameters<typeof buildComponent>[0],
    renderMappedEntry: (model: CompositionItem, key?: string | number) => ReactNode,
    key?: string | number
): ReturnType<typeof buildComponent> {
    if (!entry?.fields) return null;

    const contentType = entry.sys?.contentType?.sys?.id;
    if (contentType && transforms[contentType]) {
        const model = mapEntry(entry, transforms);
        return model ? renderMappedEntry(model, key) : null;
    }

    return buildComponent(entry, key, (child, childKey) => resolveLegacyEntry(child, renderMappedEntry, childKey));
}
